import http from '../utils/http';

export async function getVerifyCode(params) {
  const { account } = params;
  return http.get('api/admin/user/getVerifyCode'.concat(`?account=${account}`));
}
export async function checkVerifyCode(params) {
  const { account, verifyCode } = params;
  return http.get('api/admin/user/checkVerificationCode'.concat(`?account=${account}&verifyCode=${verifyCode}`));
}

export async function updatePasswordPc(params) {
  return http.post('api/admin/user/updatePasswordPc', params);
}
export async function getPasswordConfig() {
  return http.get('api/admin/user/getSysPasswordConfig');
}



// WEBPACK FOOTER //
// ./src/services/password.js